module.exports = __webpack_public_path__ + "img/kaist_main0.944a3c83.jpg";